
import styles from '../style.module.css';

function AdvantagesItem({ value, title, text, textColor = 'black', background = 'white' }) {

    return (
        <div
            className={styles.advantages_item}
            style = {{ background: `${background}` }}
        >
            <span
                style={{ color: `${textColor}` }}
            >
                { value }
            </span>
            <span style={{ color: `${textColor}` }}>
                { title }
            </span>
            <span
                style={{ color: background !== 'white' && `#FFFFFF` }}
            >
                { text }
            </span>
        </div>
    )
}

export default AdvantagesItem